import React, { Component } from "react";
import SmileyChatIcon from "./SmileyChatIcon";
class FinalView extends Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      id: "chat-view",
      className: "final-view"
    }, /*#__PURE__*/React.createElement("div", {
      className: "final-thanks"
    }, /*#__PURE__*/React.createElement(SmileyChatIcon, {
      className: "large"
    }), /*#__PURE__*/React.createElement("span", {
      className: "thanks"
    }, "Thanks for the feedback")), /*#__PURE__*/React.createElement("span", {
      className: "enjoy-rest-of-day"
    }, "Enjoy the rest of your day"));
  }
}
export default FinalView;